import styles from "./DashBoard.module.css";
import BankingStatistics from "./ManagementSubComponent/BankingStatistics";

const VESSEL_NUMBERS = ["1", "2", "3", "4"];

function DashBoard() {
    return (
        <div className={styles.fourGrid}>
            {VESSEL_NUMBERS.map((vessel) => (
                <BankingStatistics key={vessel} vessel={vessel} />
            ))}
        </div>
    );
}

export default DashBoard;